<script>
import ObjectGridAdvanced from "@/components/ObjectGridAdvanced.vue";
import ApiService from "@/api/ApiService";
import ErrorMessageWrapper from "@/components/ErrorMessageWrapper.vue";
import NotificationSnackbar from "@/components/NotificationSnackbar.vue";
import TestimonialsHeader from "@/components/feedback/TestimonialsHeader.vue";
import PromptForm from "@/components/PromptForm";
import { mapActions } from "vuex";

const URL_PUBLIC = "testimonials/";
const URL_API = "api/testimonials/";

export default {
  components: {
    TestimonialsHeader,
    NotificationSnackbar,
    ErrorMessageWrapper,
    ObjectGridAdvanced,
  },
  data() {
    return {
      isVisibleModal: false,
      isArchiveTestimonials: true,
      testimonialsList: [],
      fields: [
        {
          key: "name",
          label: "Имя",
          readonly: true,
          cols: 12,
        },
        {
          key: "phone",
          label: "Телефон",
          readonly: true,
          cols: 12,
        },
        {
          key: "message",
          label: "Сообщение",
          type: "text",
          readonly: true,
          cols: 12,
        },
        {
          key: "type",
          label: "Тип",
          readonly: true,
          cols: 12,
        },
      ],
      selectedTestimonial: {},
      isSnackbarVisible: false,
    };
  },
  computed: {
    tableFields() {
      return [
        { text: "ID", value: "id" },
        { text: "Имя", value: "name" },
        { text: "Телефон", value: "phone" },
        { text: "Тип", value: "type" },
        { text: "Дата создания", value: "createdAt" },
      ];
    },
    gridActions() {
      return {
        edit: true,
        delete: true,
        restore: false,
      };
    },
    formattedTestimonialsList() {
      return this.testimonialsList.map((item) => ({
        ...item,
        type: item.type === "director" ? "Гендиректору" : "Отзыв",
        createdAt: this.formatDate(item.createdAt),
      }));
    },
  },
  async mounted() {
    await this.getTestimonialsList();
  },
  methods: {
    ...mapActions("modals", ["showModalForm"]),
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    async getTestimonialsList() {
      const params = {};
      if (this.isArchiveTestimonials === true) {
        params.deleted = "0";
      } else if (this.isArchiveTestimonials === false) {
        params.deleted = "1";
      }
      const { data } = await ApiService.get(URL_PUBLIC, params);
      this.testimonialsList = data;
    },
    async getTestimonialById(id) {
      const { data } = await ApiService.get(URL_PUBLIC + id);
      this.selectedTestimonial = {
        ...data,
        type: data.type === "director" ? "Гендиректору" : "Отзыв",
      };
    },
    async openModalTestimonial(testimonial) {
      this.selectedTestimonial = {};
      await this.getTestimonialById(testimonial.id);
      this.isVisibleModal = true;
    },
    async deleteTestimonialById(testimonial) {
      await this.showModalForm({
        component: PromptForm,
        title: "Вы уверены что хотите архивировать отзыв?",
        desc: "Подтвердите действие",
        value: testimonial,
      });

      const { data } = await ApiService.put(URL_API + testimonial.id, {
        active: false,
      });
      if (data.error) {
        await this.$refs.error_wrapper.showErrorMessage("Ошибка", data.error);
      } else {
        this.isSnackbarVisible = true;
        await this.getTestimonialsList();
      }
    },
  },
  watch: {
    isArchiveTestimonials() {
      this.getTestimonialsList();
    },
  },
};
</script>

<template>
  <div>
    <notification-snackbar :value.sync="isSnackbarVisible" />
    <testimonials-header
      module-name="Отзывы с сайта"
      :value.sync="isArchiveTestimonials"
    />
    <object-grid-advanced
      :value="formattedTestimonialsList"
      :field-defs="tableFields"
      :show-actions="gridActions"
      title="Отзывы с сайта"
      @doEditItem="openModalTestimonial"
      @doDeleteItem="deleteTestimonialById"
    />
    <v-dialog v-model="isVisibleModal" max-width="600">
      <v-card>
        <v-card-title>Просмотр отзыва</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="selectedTestimonial.name"
            label="Имя"
            readonly
            outlined
          ></v-text-field>
          <v-text-field
            v-model="selectedTestimonial.phone"
            label="Телефон"
            readonly
            outlined
          ></v-text-field>
          <v-textarea
            v-model="selectedTestimonial.message"
            label="Сообщение"
            readonly
            outlined
            rows="5"
          ></v-textarea>
          <v-text-field
            v-model="selectedTestimonial.type"
            label="Тип"
            readonly
            outlined
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="isVisibleModal = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <error-message-wrapper ref="error_wrapper" />
  </div>
</template>

<style scoped lang="scss"></style>
